import React from "react";
import './Loader.css';
const Loader = () => {
  return (
    <div>
      <div className="loader">
        <div className="panWrapper">
          <div className="pan">
            <div className="food"></div>
            <div className="panBase"></div>
            <div className="panHandle"></div>
          </div>
          <div className="panShadow"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
